import { Descriptions } from "antd";
import { formatDate, getStatus } from "helpers/utility";
import { Link, useLocation } from "react-router-dom";

const DeviceDetails = () => {
  const {
    state: { details },
  } = useLocation();
  return (
    <div>
      <Descriptions title="Device details">
        <Descriptions.Item label="Company name">
          {details.companyName}
        </Descriptions.Item>
        <Descriptions.Item label="Serial no.">
          {details.serialNo}
        </Descriptions.Item>
        <Descriptions.Item label="Model no.">
          {details.modelNo}
        </Descriptions.Item>
        <Descriptions.Item label="Customer name">
          {details.customerName}
        </Descriptions.Item>
        <Descriptions.Item label="Activated on">
          {formatDate(details.activatedOn)}
        </Descriptions.Item>
        <Descriptions.Item label="Expiry date">
          {formatDate(details.expiryDate)}
        </Descriptions.Item>
        <Descriptions.Item label="Authorization key" span={2}>
          {details.authorizationKey}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          {getStatus(details.active)}
        </Descriptions.Item>
      </Descriptions>
      <Link to="/devices/devices">Back to list</Link>
    </div>
  );
};
export default DeviceDetails;
